import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { lighten, rem, transparentize } from 'polished';
import { baseTheme } from '~base-theme';
import { typographyTheme } from '~typography';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-47avm-0"
})(["align-content:center;align-items:flex-start;border:0 solid transparent;border-radius:", ";display:flex;font-family:", ";justify-content:space-between;overflow:hidden;padding:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, rem(16), function (_ref3) {
  var theme = _ref3.theme,
      alertType = _ref3.alertType;
  return alertType && css(["background-color:", ";border-color:", ";color:", ";"], transparentize(0.15, _get(theme, "base.colors[" + alertType + "]", baseTheme.base.colors[alertType])), _get(theme, "base.colors[" + alertType + "]", baseTheme.base.colors[alertType]), lighten(0.9, _get(theme, "base.colors[" + alertType + "]", baseTheme.base.colors[alertType])));
});
export default Container;